import React from 'react';
import t from 'react-translate';
import NvSwitch from 'shared/components/inputs/nv-switch';

type DailySftpSwitchProps = {
  isDailysftp: boolean
  toggleSftpReport: () => void
};

const DailySftpSwitch: React.FC<DailySftpSwitchProps> = ({
  isDailysftp,
  toggleSftpReport,
}) => (
  <div className='d-flex justify-content-between gray-1 px-4 py-1'>
    {t.CUSTOM_DOWNLOADS.DAILY_SFTP()}
    <NvSwitch
      checked={isDailysftp}
      onChange={toggleSftpReport}
      enabledLabel={t.SHARED.ON().toUpperCase()}
      disabledLabel={t.SHARED.OFF().toUpperCase()}
    />
  </div>
);


export default DailySftpSwitch;
